import { Box, Checkbox, InfoIcon, Text } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext, ZIndexContext } from './../../ricos-context';

export const CheckboxWithInfoIcon: React.FC<{
  checked: boolean | undefined;
  onChange: () => void;
  textContent: string;
  tooltipContent: string | null;
  dataHook: string;
}> = ({ checked, onChange, textContent, tooltipContent, dataHook }) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);

  return (
    <Checkbox dataHook={dataHook} size="small" checked={checked} onChange={onChange}>
      {tooltipContent ? (
        <Box verticalAlign="middle" gap="SP1">
          <Text size="small">{t(textContent)}</Text>
          <InfoIcon
            size="small"
            content={t(tooltipContent)}
            tooltipProps={{
              appendTo: el => Boolean(el.getAttribute('data-hook')?.includes('ricos-portal')),
              zIndex: zIndexService.getZIndex('TOOLTIP'),
            }}
          />
        </Box>
      ) : (
        <Text size="small">{t(textContent)}</Text>
      )}
    </Checkbox>
  );
};
